import { useState } from 'react';
import { Link } from 'react-router-dom';
import { Header } from '../../components/feature/Header';
import { Footer } from '../../components/feature/Footer';
import { ProductCard } from '../../components/base/ProductCard';
import { products } from '../../mocks/products';

export default function HomePage() {
  const [activeTab, setActiveTab] = useState<'popular' | 'new' | 'deals'>('popular');

  const getFilteredProducts = () => {
    switch (activeTab) {
      case 'new':
        return products.filter(p => p.isNew).slice(0, 8);
      case 'deals':
        return products.filter(p => p.discount).slice(0, 8);
      default:
        return products.filter(p => p.isFeatured).slice(0, 8);
    }
  };

  const filteredProducts = getFilteredProducts();

  return (
    <div className="min-h-screen bg-white font-poppins">
      <Header />

      {/* Hero Section - Minimal & Modern */}
      <section className="relative min-h-[85vh] flex items-center justify-center overflow-hidden">
        <div className="absolute inset-0">
          <img
            src="https://public.readdy.ai/ai/img_res/e15ac2efe2d55260360bc4e990247026.jpg"
            alt="Hero Background"
            className="w-full h-full object-cover object-center"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-white/40 via-white/20 to-white/60"></div>
        </div>

        <div className="relative z-10 text-center px-4 w-full max-w-4xl mx-auto">
          <div className="mb-8">
            <span className="inline-block text-sm font-medium text-amber-700 tracking-wider uppercase mb-4">
              30 Yıllık Güven
            </span>
            <h1 className="text-6xl md:text-7xl lg:text-8xl font-light text-gray-900 mb-6 leading-tight tracking-tight">
              Zarafet<br />
              <span className="font-semibold">Altında Gizli</span>
            </h1>
            <p className="text-lg md:text-xl text-gray-700 mb-12 max-w-2xl mx-auto font-light leading-relaxed">
              Sertifikalı altın koleksiyonumuzla zamansız güzelliği keşfedin
            </p>
          </div>
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
            <Link
              to="/kategori"
              className="inline-block bg-gray-900 text-white px-12 py-4 rounded-full text-base font-medium hover:bg-gray-800 transition-all whitespace-nowrap cursor-pointer"
            >
              Koleksiyonu Keşfet
            </Link>
          </div>
        </div>
      </section>

      {/* Trust Badges - Minimal */}
      <section className="py-16 bg-gray-50 border-y border-gray-100">
        <div className="container mx-auto px-4">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-8 max-w-5xl mx-auto">
            <div className="flex flex-col items-center text-center gap-3">
              <div className="w-14 h-14 flex items-center justify-center">
                <i className="ri-shield-check-line text-3xl text-gray-900"></i>
              </div>
              <div>
                <div className="font-medium text-gray-900 text-sm">Sertifikalı</div>
                <div className="text-xs text-gray-500 mt-1">Güvenilir Ürünler</div>
              </div>
            </div>
            <div className="flex flex-col items-center text-center gap-3">
              <div className="w-14 h-14 flex items-center justify-center">
                <i className="ri-truck-line text-3xl text-gray-900"></i>
              </div>
              <div>
                <div className="font-medium text-gray-900 text-sm">Ücretsiz Kargo</div>
                <div className="text-xs text-gray-500 mt-1">Sigortalı Teslimat</div>
              </div>
            </div>
            <div className="flex flex-col items-center text-center gap-3">
              <div className="w-14 h-14 flex items-center justify-center">
                <i className="ri-bank-card-line text-3xl text-gray-900"></i>
              </div>
              <div>
                <div className="font-medium text-gray-900 text-sm">12 Taksit</div>
                <div className="text-xs text-gray-500 mt-1">Ödeme Kolaylığı</div>
              </div>
            </div>
            <div className="flex flex-col items-center text-center gap-3">
              <div className="w-14 h-14 flex items-center justify-center">
                <i className="ri-customer-service-2-line text-3xl text-gray-900"></i>
              </div>
              <div>
                <div className="font-medium text-gray-900 text-sm">7/24 Destek</div>
                <div className="text-xs text-gray-500 mt-1">Müşteri Hizmetleri</div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Featured Products - Minimal */}
      <section className="py-24 bg-white">
        <div className="container mx-auto px-4">
          <div className="text-center mb-16 max-w-2xl mx-auto">
            <span className="inline-block text-sm font-medium text-amber-700 tracking-wider uppercase mb-3">
              Koleksiyon
            </span>
            <h2 className="text-4xl md:text-5xl font-light text-gray-900 mb-4">
              Öne Çıkan Ürünler
            </h2>
            <p className="text-gray-600 text-base font-light">
              En çok tercih edilen ve yeni eklenen ürünlerimizi keşfedin
            </p>
          </div>

          <div className="flex justify-center mb-12">
            <div className="inline-flex bg-gray-50 rounded-full p-1">
              <button
                onClick={() => setActiveTab('popular')}
                className={`px-8 py-3 rounded-full text-sm font-medium transition-all whitespace-nowrap cursor-pointer ${
                  activeTab === 'popular'
                    ? 'bg-gray-900 text-white'
                    : 'text-gray-600 hover:text-gray-900'
                }`}
              >
                Popüler
              </button>
              <button
                onClick={() => setActiveTab('new')}
                className={`px-8 py-3 rounded-full text-sm font-medium transition-all whitespace-nowrap cursor-pointer ${
                  activeTab === 'new'
                    ? 'bg-gray-900 text-white'
                    : 'text-gray-600 hover:text-gray-900'
                }`}
              >
                Yeni Gelenler
              </button>
              <button
                onClick={() => setActiveTab('deals')}
                className={`px-8 py-3 rounded-full text-sm font-medium transition-all whitespace-nowrap cursor-pointer ${
                  activeTab === 'deals'
                    ? 'bg-gray-900 text-white'
                    : 'text-gray-600 hover:text-gray-900'
                }`}
              >
                Fırsatlar
              </button>
            </div>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 mb-12">
            {filteredProducts.map((product) => (
              <ProductCard key={product.id} product={product} />
            ))}
          </div>

          <div className="text-center">
            <Link
              to="/kategori"
              className="inline-block bg-gray-900 text-white px-12 py-4 rounded-full text-sm font-medium hover:bg-gray-800 transition-all whitespace-nowrap cursor-pointer"
            >
              Tüm Ürünleri Görüntüle
            </Link>
          </div>
        </div>
      </section>

      {/* About Section - Minimal */}
      <section className="py-24 bg-gray-50">
        <div className="container mx-auto px-4">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center max-w-6xl mx-auto">
            <div className="relative h-[500px] rounded-2xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Elegant%20minimalist%20gold%20jewelry%20workshop%20scene%20with%20artisan%20crafting%20delicate%20gold%20pieces%2C%20soft%20natural%20window%20lighting%2C%20clean%20white%20workspace%2C%20professional%20craftsmanship%20photography%2C%20modern%20luxury%20aesthetic%20with%20warm%20golden%20tones%20and%20sophisticated%20composition&width=800&height=800&seq=about-minimal-1&orientation=squarish"
                alt="Emin Kuyumculuk"
                className="w-full h-full object-cover object-center"
              />
            </div>
            <div>
              <span className="inline-block text-sm font-medium text-amber-700 tracking-wider uppercase mb-3">
                Hakkımızda
              </span>
              <h2 className="text-4xl md:text-5xl font-light text-gray-900 mb-6">
                30 Yıllık<br />
                <span className="font-semibold">Güven ve Tecrübe</span>
              </h2>
              <p className="text-gray-600 text-base leading-relaxed mb-6 font-light">
                1994 yılından bu yana altın sektöründe hizmet veren Emin Kuyumculuk, kaliteli ürünleri ve güvenilir hizmet anlayışıyla müşterilerinin tercih ettiği bir marka haline gelmiştir.
              </p>
              <p className="text-gray-600 text-base leading-relaxed mb-8 font-light">
                Sertifikalı ürünlerimiz, sigortalı kargo hizmetimiz ve müşteri memnuniyeti odaklı yaklaşımımızla her zaman yanınızdayız.
              </p>
              <Link
                to="/hakkimizda"
                className="inline-flex items-center gap-2 text-gray-900 font-medium hover:gap-3 transition-all cursor-pointer"
              >
                Daha Fazla Bilgi
                <i className="ri-arrow-right-line"></i>
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* Promotional Banner - New Design */}
      <section className="py-20 bg-gradient-to-br from-amber-500 via-amber-600 to-orange-600 relative overflow-hidden">
        <div className="absolute inset-0 opacity-10">
          <div className="absolute top-10 left-10 w-64 h-64 bg-white rounded-full blur-3xl"></div>
          <div className="absolute bottom-10 right-10 w-96 h-96 bg-white rounded-full blur-3xl"></div>
        </div>
        
        <div className="container mx-auto px-4 relative z-10">
          <div className="max-w-5xl mx-auto">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
              <div className="text-white">
                <div className="inline-block bg-white/20 backdrop-blur-sm px-4 py-2 rounded-full text-sm font-medium mb-6">
                  <i className="ri-gift-line mr-2"></i>
                  Özel Kampanya
                </div>
                <h2 className="text-4xl md:text-5xl font-light mb-6 leading-tight">
                  Yeni Sezon<br />
                  <span className="font-bold">Koleksiyonu</span>
                </h2>
                <p className="text-lg mb-8 text-white/90 font-light leading-relaxed">
                  Tüm yeni sezon ürünlerinde özel indirimler ve 12 taksit imkanı. Sınırlı sayıda, kaçırmayın!
                </p>
                <div className="flex flex-col sm:flex-row gap-4">
                  <Link
                    to="/kategori"
                    className="inline-block bg-white text-amber-600 px-10 py-4 rounded-full text-sm font-semibold hover:bg-gray-50 transition-all whitespace-nowrap cursor-pointer shadow-lg"
                  >
                    Hemen Keşfet
                  </Link>
                  <Link
                    to="/iletisim"
                    className="inline-block bg-transparent border-2 border-white text-white px-10 py-4 rounded-full text-sm font-semibold hover:bg-white/10 transition-all whitespace-nowrap cursor-pointer"
                  >
                    Bize Ulaşın
                  </Link>
                </div>
              </div>
              
              <div className="relative h-[400px] lg:h-[450px]">
                <div className="absolute inset-0 bg-white/10 backdrop-blur-sm rounded-3xl"></div>
                <img
                  src="https://readdy.ai/api/search-image?query=Elegant%20luxury%20gold%20jewelry%20collection%20display%20on%20pristine%20white%20marble%20surface%20with%20soft%20dramatic%20lighting%2C%20featuring%20exquisite%20gold%20necklaces%20bracelets%20and%20rings%20arranged%20artistically%2C%20professional%20high-end%20jewelry%20photography%20with%20warm%20golden%20reflections%20and%20sophisticated%20minimalist%20composition%20showcasing%20premium%20craftsmanship&width=800&height=900&seq=banner-promo-jewelry-1&orientation=portrait"
                  alt="Yeni Sezon Koleksiyonu"
                  className="w-full h-full object-cover object-center rounded-3xl shadow-2xl"
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Testimonials - Minimal */}
      <section className="py-24 bg-white">
        <div className="container mx-auto px-4">
          <div className="text-center mb-16 max-w-2xl mx-auto">
            <span className="inline-block text-sm font-medium text-amber-700 tracking-wider uppercase mb-3">
              Referanslar
            </span>
            <h2 className="text-4xl md:text-5xl font-light text-gray-900 mb-4">
              Müşteri Görüşleri
            </h2>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-6xl mx-auto">
            <div className="bg-gray-50 p-8 rounded-2xl">
              <div className="flex items-center gap-1 mb-6">
                {[...Array(5)].map((_, i) => (
                  <i key={i} className="ri-star-fill text-amber-600 text-base"></i>
                ))}
              </div>
              <p className="text-gray-700 mb-6 leading-relaxed text-sm font-light">
                "30 yıldır güvendiğim tek kuyumcu. Ürünlerin kalitesi ve müşteri memnuniyeti her zaman ön planda."
              </p>
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 bg-gray-200 rounded-full flex items-center justify-center">
                  <span className="text-gray-700 font-medium text-sm">AY</span>
                </div>
                <div>
                  <div className="font-medium text-gray-900 text-sm">Ayşe Yılmaz</div>
                  <div className="text-xs text-gray-500">Ankara</div>
                </div>
              </div>
            </div>

            <div className="bg-gray-50 p-8 rounded-2xl">
              <div className="flex items-center gap-1 mb-6">
                {[...Array(5)].map((_, i) => (
                  <i key={i} className="ri-star-fill text-amber-600 text-base"></i>
                ))}
              </div>
              <p className="text-gray-700 mb-6 leading-relaxed text-sm font-light">
                "Online sipariş verdim, ertesi gün sigortalı kargo ile elime ulaştı. Ürün tam istediğim gibi."
              </p>
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 bg-gray-200 rounded-full flex items-center justify-center">
                  <span className="text-gray-700 font-medium text-sm">MK</span>
                </div>
                <div>
                  <div className="font-medium text-gray-900 text-sm">Mehmet Kaya</div>
                  <div className="text-xs text-gray-500">İstanbul</div>
                </div>
              </div>
            </div>

            <div className="bg-gray-50 p-8 rounded-2xl">
              <div className="flex items-center gap-1 mb-6">
                {[...Array(5)].map((_, i) => (
                  <i key={i} className="ri-star-fill text-amber-600 text-base"></i>
                ))}
              </div>
              <p className="text-gray-700 mb-6 leading-relaxed text-sm font-light">
                "Fiyatlar çok uygun ve ürün kalitesi mükemmel. Taksit imkanı sayesinde hayalimdeki bileziklere kavuştum."
              </p>
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 bg-gray-200 rounded-full flex items-center justify-center">
                  <span className="text-gray-700 font-medium text-sm">ZD</span>
                </div>
                <div>
                  <div className="font-medium text-gray-900 text-sm">Zeynep Demir</div>
                  <div className="text-xs text-gray-500">İzmir</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Newsletter - Minimal */}
      <section className="py-20 bg-gray-900">
        <div className="container mx-auto px-4">
          <div className="max-w-2xl mx-auto text-center">
            <h2 className="text-3xl md:text-4xl font-light text-white mb-4">
              Kampanyalardan Haberdar Olun
            </h2>
            <p className="text-gray-400 text-base mb-8 font-light">
              Özel fırsatlar ve yeni ürünler hakkında bilgi almak için abone olun
            </p>
            <form className="flex flex-col sm:flex-row gap-3 max-w-md mx-auto">
              <input
                type="email"
                placeholder="E-posta adresiniz"
                className="flex-1 px-6 py-4 rounded-full text-gray-900 focus:outline-none focus:ring-2 focus:ring-gray-700 text-sm"
              />
              <button
                type="submit"
                className="bg-white text-gray-900 px-8 py-4 rounded-full font-medium hover:bg-gray-100 transition-colors whitespace-nowrap cursor-pointer text-sm"
              >
                Abone Ol
              </button>
            </form>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
